import React from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from 'components/Tooltip/Tooltip';
import LinkButton from 'components/LinkButton/LinkButton';
import { BooksLibraryIcon, OutlinedPlusIcon } from 'components/SvgIcons';
import useFormattedDate, { FULL_MONTH_WITH_TIME_AND_TIMEZONE } from 'hooks/useFormattedDate';
import { useSelector } from 'store';

import './LoggedInActions.scss';

const LoggedInActions = () => {
  const { t } = useTranslation();

  const rfp = useSelector((state) => state.rfp.data);

  const openDate = useFormattedDate(rfp.open_date ?? '', FULL_MONTH_WITH_TIME_AND_TIMEZONE);
  const closeDate = useFormattedDate(rfp.response_close_date, FULL_MONTH_WITH_TIME_AND_TIMEZONE);

  return (
    <div className="actions enkrateia-logged-in-actions">
      <Tooltip
        tooltip={t('pages.prosforaProject.newBidDisabledTooltip', { openDate, closeDate })}
        disabled={rfp.is_response_open}
      >
        <LinkButton
          variant="dark-green-filled"
          to={`/rfp/${rfp.id}/bid-sheet`}
          disabled={!rfp.is_response_open}
          fullWidth
        >
          <OutlinedPlusIcon size={26} color="white" />
          <span className="link">{t('pages.prosforaProject.newBid')}</span>
        </LinkButton>
      </Tooltip>
      <LinkButton variant="tertiary-filled" to={`/rfp/${rfp.id}/data-room`}>
        <BooksLibraryIcon size={32} color="white" />
        <span className="link">{t('pages.prosforaProject.auctionDocuments')}</span>
      </LinkButton>
      <LinkButton variant="black-thick" to="/organization">
        <span className="link">{t('pages.prosforaProject.companyProfile')}</span>
      </LinkButton>
    </div>
  );
};

export default LoggedInActions;
